export default __webpack_public_path__ + "static/prescriber-30950effd2f04d03361401672c45c81e.webp";